import { useState } from 'react'
import type { PuzzleRendererProps } from '@/game/PuzzleRenderer'

type Item = { id: string; label: string }
type Config = { left?: Item[]; right?: Item[] }

/** One selector per left-hand item (reliable on mobile). Submits { pairs: { leftId: rightId } }. */
export function MatchingPuzzle({ puzzle, onSubmit, disabled }: PuzzleRendererProps) {
  const { left = [], right = [] } = puzzle.publicConfig as Config
  const [pairs, setPairs] = useState<Record<string, string>>({})
  const complete = left.every((l) => pairs[l.id])

  return (
    <div className="puzzle-form">
      <div className="pairs">
        {left.map((l) => (
          <div className="field" key={l.id}>
            <label htmlFor={`match-${puzzle.id}-${l.id}`}>{l.label}</label>
            <select
              id={`match-${puzzle.id}-${l.id}`}
              value={pairs[l.id] ?? ''}
              onChange={(e) => setPairs((p) => ({ ...p, [l.id]: e.target.value }))}
              disabled={disabled}
            >
              <option value="">Choose…</option>
              {right.map((r) => (
                <option key={r.id} value={r.id}>
                  {r.label}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
      <button type="button" className="primary" disabled={disabled || !complete} onClick={() => void onSubmit({ pairs })}>
        {disabled ? 'Checking…' : 'Submit matches'}
      </button>
    </div>
  )
}
